import { render } from "./Nightv2.vue?vue&type=template&id=487cedda&scoped=true"
import script from "./Nightv2.vue?vue&type=script&lang=js"
export * from "./Nightv2.vue?vue&type=script&lang=js"

import "./Nightv2.vue?vue&type=style&index=0&id=487cedda&lang=scss&scoped=true"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487cedda"]])

export default __exports__